import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import SectionLayout from '../layout/SectionLayout';
import { useCompanyData } from '../contexts/DataContext';
import makeStyles from '@mui/styles/makeStyles';
import { SectionTitle as T1SectionTitle, SectionSubtitle as T1SectionSubTitle } from '../../Template1/components/SectionTitle';
import { SectionTitle as T2SectionTitle, SectionSubtitle as T2SectionSubTitle } from '../../Template2/components/SectionTitle';
import { SectionTitle as T3SectionTitle, SectionSubtitle as T3SectionSubTitle } from '../../Template3/components/SectionTitle';
import { SectionTitle as T4SectionTitle, SectionSubtitle as T4SectionSubTitle } from '../../Template4/components/SectionTitle';
import imgServices from 'src/assets/images/templates/t3/services.svg';
import Rating from '@mui/material/Rating'
import '../../shared/styles.css';
import { Typography, useMediaQuery } from '@mui/material';
import useRTL from 'src/hooks/useRTL';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
import { theme } from '../../Template3/Template';
import NoImage from 'src/assets/images/no-pictures.png'
import { textVariant, textClasses } from '../config';
import { BGSectionTitle } from '../../Template3/screens/Home'
import '../../shared/styles.css'

const useStyles = makeStyles((theme) => ({
    cardShadow:props => ({
        boxShadow: props.shadow ? props?.shadow : props.defaultShadow ? props.defaultShadow : 'none',
        "-webkit-box-shadow": props.shadow ? props?.shadow : props.defaultShadow ? props.defaultShadow : 'none',
        "-moz-box-shadow": props.shadow ? props?.shadow : props.defaultShadow ? props.defaultShadow : 'none'
    }),

    card5BtnCl:{
        background: 'rgb(2,0,36)',
        background: '-moz-linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%)',
        background: '-webkit-linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%)',
        background: 'linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 0%, rgba(0,212,255,1) 100%)',
    },

    cardListDiv:{
        display:'flex',
        alignItems:"stretch",
        flexDirection:'row',
        width:"100%",
        margin:"auto",
        [theme.breakpoints.down('md')]: {
            flexDirection:'column',
            justifyContent:'center !important'
        }
    }
}));

const fontFamilyList = {
  '1': "'Nunito Sans', sans-serif",
  '2': "'Roboto', sans-serif",
  '3': "'Poppins', sans-serif",
  '4': "'Nunito Sans', sans-serif",
};

const TitleList = {
    '1': T1SectionTitle,
    '2': T2SectionTitle,
    '3': T3SectionTitle,
    '4': T4SectionTitle,
};

const SubTitleList = {
    '1': T1SectionSubTitle,
    '2': T2SectionSubTitle,
    '3': T3SectionSubTitle,
    '4': T4SectionSubTitle,
};


export default function Testimonial({ contentData, index }) {
    const isMounted = React.useRef(null);
    const { data } = useCompanyData();
    const { isRTL, themeDesign } = data;
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const {backgroundColor, backgroundImage, backgroundStyle, title, arTitle, subTitle, arSubTitle, selectedCategories, titleFormat, titleFontSize, subTitleFontSize, titleFontColor, subTitleFontColor, paddingTop, paddingBottom } = contentData || {};
    const classes = useStyles();
  
    const _title = title ? (isRTL === 'ar' ? (arTitle ? arTitle : title) : title) : 'Clients Feedback';
    const _subTitle = subTitle ? (isRTL === 'ar' ? (arSubTitle ? arSubTitle : subTitle) : subTitle) : 'REVIEWS';
  

    const TitleComponent = TitleList?.[themeDesign];
    const SubTitleComponent = SubTitleList?.[themeDesign];

    // const cardList = {
    //     // 'CardDesign_1': CardDesign_1,
    //     // 'CardDesign_2': CardDesign_2,
    //     // 'CardDesign_3': CardDesign_3,
    //     'CardDesign_4': CardDesign_4,
    //     // 'CardDesign_5': CardDesign_5
    // };

    // const CardComponent = cardList[contentData['cardDesign']];
    const filterList = contentData?.cardList?.filter(v=> v.title);
  
    return (
      <Box
        style={{
          width:'100%',
          ...(backgroundStyle === 'image' && backgroundImage ?
            {
              backgroundImage: `url(${backgroundImage})`,
              backgroundSize: "cover",
              backgroundRepeat: 'no-repeat',
            }
            :
            backgroundStyle === 'gradient' ? 
            {backgroundImage: backgroundColor} 
            : {backgroundColor: backgroundColor || '#fff'}
          )
        }}
      >
        <SectionLayout paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <Box width="100%" m="auto" position="relative">

          <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
            <SubTitleComponent pFontSize={subTitleFontSize} color={subTitleFontColor}>{_subTitle}</SubTitleComponent>
            <TitleComponent pFontSize={titleFontSize} color={titleFontColor} variant={titleFormat}>{_title}</TitleComponent>
          </Box>
          <Box className={classes.cardListDiv} style={{justifyContent: filterList?.length <= 2 ? 'center' : contentData?.spaceBetween ? contentData?.spaceBetween : 'space-between'}}>
            {React.Children.toArray(filterList.map((v,i)=> {
              if(v.title) {
                  return(
                      <CardDesign_4
                          
                          {...{...v, 
                          filterList,
                          title: v.title,
                          arTitle: v.arTitle,
                          subTitle: v.subTitle,
                          arSubTitle: v.arSubTitle,
                          description: v.description,
                          arDescription:  v.arDescription,
                          contentData,TitleComponent,index:i,SubTitleComponent}}
                      />
                  )
              }
            }))}
          </Box>
        </Box>
        </SectionLayout>
      </Box>
    );
};


function CardDesign_4(props) {
    const mobileView = useMediaQuery(theme.breakpoints.down('md'));
    const { data } = useCompanyData();
    const { title, description, arTitle, arSubTitle, subTitle, arDescription, buttonTitle, arButtonTitle, image, externalLink, path, contentData, TitleComponent, SubTitleComponent, index, filterList } = props || {};
    const { isRTL, themeDesign, companyDomain, buttonColor, buttonFontColor, buttonRadiusGeneral, buttonFontSize } = data || {};
    const { cardTitleFontSize, cardSubTitleFontSize, cardTextFontSize, cardTitleColor, cardSubTitleColor, cardTextColor } = contentData || {};
    const { pathname:url } = useLocation();
    const navigate = useNavigate();
    const classes = useStyles({shadow:contentData?.shadow,defaultShadow:'0px 4px 15px -3px rgba(0,0,0,0.1), -2px -2px 15px -3px rgba(0,0,0,0.1)'});
    const [, , themeFontFamily] = useRTL('',fontFamilyList?.[themeDesign]);

    const cardRadius = contentData?.cardRadius ? `${contentData?.cardRadius}px` : '12px'; 
    const cardBorder = contentData?.border || 'none'; 


    const titleFontSize = cardTitleFontSize ? cardTitleFontSize : '14';
    const subTitleFontSize = cardSubTitleFontSize ? cardSubTitleFontSize: '14';
    const descriptionFontSize = cardTextFontSize ? cardTextFontSize : '14';
    const titleFontColor = cardTitleColor ? cardTitleColor : '#110729';
    const subTitleFontColor = cardSubTitleColor ? cardSubTitleColor: '#0F2240';
    const descFontColor = cardTextColor ? cardTextColor : '#696969';

    const titleText = isRTL === 'ar' && arTitle ? arTitle : title;
    const subTitleText = isRTL === 'ar' && arSubTitle ? arSubTitle : subTitle;
    const descriptionText = isRTL === 'ar' && arDescription ? arDescription : description;

    const imgStyle = { width: '100%', height: '100%', objectFit: 'cover' };
    const cardMargin = !mobileView ? isRTL === 'ar' ? {ml: 2} : {mr: 2} : {};

    return (
        (<Box display="flex" flexDirection="column"
        maxWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        minWidth={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        width={{xs: '100%', sm: '100%', md: "calc(100% / 3.1)", lg: "calc(100% / 3.1)", xl: "420px" }}
        style={{
            ...((contentData?.cardBackgroundStyle === 'image' && contentData?.cardBackgroundImage) ? 
                {
                    backgroundSize: "cover",
                    backgroundImage: `url(${contentData?.cardBackgroundImage})`,
                    backgroundRepeat: "no-repeat",
                } 
            : 
            (contentData?.cardBackgroundStyle === 'gradient' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundImage: contentData?.cardBackgroundColor ? contentData?.cardBackgroundColor : '#ffffff',
                } 
            :
            (contentData?.cardBackgroundStyle === 'solidColor' && contentData?.cardBackgroundColor) ? 
                {
                    backgroundColor: contentData?.cardBackgroundColor || '#ffffff',
                } 
            : 
            {backgroundColor: '#ffffff'}
            ),
            ...(filterList?.length === 2 ? (isRTL === 'ar' ? {marginLeft:'30px'} : {marginRight:'30px'}) : {})
            }}
        border={cardBorder}
        borderRadius={cardRadius}
        className={classes.cardShadow}
        minHeight='332px'
        mb={mobileView ? 3.5 : '10px'}
        {...(contentData?.spaceBetween === 'center' ? 
            {...cardMargin}
            : {}
        )}
        >
            <Box display="flex" flexDirection={"column"} px="20px" py='28px' width="calc(100% - 40px)">
                {/* <Box height="150px" bgcolor={contentData?.iconBackgroundColor || "#00346e"}
                width="115px"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                style={{borderBottomLeftRadius:'8px',borderBottomRightRadius:'8px'}}
                >
                    <Box width="70%" height="70%">
                        <ImgLazyLoad height="80%" width="80%">
                            <img
                            style={{...imgStyle}}
                            src={image || NoImage}
                            alt={title || 'feature'}
                            />
                        </ImgLazyLoad>
                    </Box>
                </Box> */}
                <Box width="80px" height="80px">
                        <ImgLazyLoad height="100%" width="100%">
                            <img
                            style={{...imgStyle}}
                            src={image || NoImage}
                            alt={title || 'testimonial'}
                            />
                        </ImgLazyLoad>
                    </Box>

                <Box
                    pt={'15px'}
                    // px={"10px"}
                    // px={['left','right']?.includes(contentData?.textAlign) ? 2 : ''}
                    textAlign={isRTL === 'ar' && 
                    (['left']?.includes(contentData?.textAlign) || !contentData?.textAlign) ?
                    'right' :
                    contentData?.textAlign || 'left'}
                    width={"100%"}
                >
                    <TitleComponent pb='5px' noWrap pFontSize={titleFontSize} contentSection={true} {...(titleFontColor ? {color: titleFontColor} : {} )}>
                    {titleText}
                    </TitleComponent>
                    <TitleComponent pb="5px" noWrap pFontSize={subTitleFontSize} contentSection={true} {...(subTitleFontColor ? {color: subTitleFontColor} : {} )}>
                    {subTitleText}
                    </TitleComponent>
                    <Rating name="half-rating-read" defaultValue={4.5} precision={0.5} readOnly style={{direction:'ltr'}}/>

                    <Box 
                    // style={{height:'80px',maxHeight:'80px', overflow:'hidden'}}
                     color={descFontColor}>
                        <Typography
                            variant={descriptionFontSize && textVariant?.[descriptionFontSize] ? textVariant?.[descriptionFontSize] : textVariant?.['18']}
                            className={descriptionFontSize && textClasses?.[descriptionFontSize] ? textClasses?.[descriptionFontSize] : textClasses?.['18']}
                            style={{fontFamily:themeFontFamily}}
                        >
                        {descriptionText}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>)
    );
}